<template>
  <landing-home />
</template>

<script setup lang="ts">
import LandingHome from "@/components/v2/landing-home/index.vue";

defineOptions({
  name: "home-page",
});
</script>
